import { InboxOutlined } from '@ant-design/icons'
import { UploadProps } from 'antd'
import Dragger from 'antd/lib/upload/Dragger'
import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import styles from './pure-file-upload.module.scss'

type PureFileUploadProps = {
  disabled?: boolean
  label?: string
  required?: boolean
  multiple?: boolean
}

export const PureFileUpload = ({ disabled, label, required, multiple = true }: PureFileUploadProps) => {
  const { t } = useTranslation()

  const props: UploadProps = {
    name: 'file',
    multiple,
    action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
    onChange(info) {
      const { status } = info.file
      if (status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (status === 'done') {
        toast.success(`${info.file.name} file uploaded successfully.`)
      } else if (status === 'error') {
        toast.error(`${info.file.name} file upload failed.`)
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files)
    },
  }

  return (
    <div className={clsx('d-flex flex-column', styles.inputStyles)}>
      <div className="label d-block mt-2 mb-1 fs-6">
        {label}
        {required ? <span className={clsx(styles.required)}>*</span> : null}
      </div>
      <Dragger
        disabled={disabled}
        {...props}
        style={{
          height: 100,
          padding: 8,
        }}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">{t('common.fileUpload')}</p>
      </Dragger>
    </div>
  )
}
